// extracted by mini-css-extract-plugin
export default {"wrapper":"NavBar_wrapper__i+SF9","mobile":"NavBar_mobile__FoqEh"};